<template>
     <div class="vue-select">
         <input type="hidden" :name="name" v-model="selected">
         <v-select
            multiple
            :label="label"
            :name="name"
            :options="options"
            v-model="selected"
            :reduce="option => option.id"
        />
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import Vue from "vue";

    Vue.component('v-select', vSelect)

    export default {
        props: {
            options: Array,
            label: String,
            name: String
        },
        data: function() {
            return {
                selected: null
            }
        },
    }

</script>

<style>

.vue-select .vs__dropdown-toggle {
   min-height: 40px;
   background-color: #fff;
}

</style>
